var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import '../../components/button';
let ErrorComponent = class ErrorComponent extends BaseComponent {
    constructor() {
        super(...arguments);
        this.iconName = "Error";
    }
    render() {
        return html `
      <div data-test="error" class="flex flex-col justify-center items-center text-center">
        <trust-icon name=${this.iconName} classNames="w-[16rem] h-[16rem]" ></trust-icon>
        ${this.header ? html `<h1 class="font-md h3 md:h1">${this.header}</h3>` : nothing}
        ${this.lead ? html `<p class="text-base mb-24">${this.lead}</p>` : nothing}
        ${this.buttonText ? html `<trust-button primary>${this.buttonText}</trust-button>` : nothing}
    `;
    }
};
__decorate([
    property({ type: String })
], ErrorComponent.prototype, "header", void 0);
__decorate([
    property({ type: String })
], ErrorComponent.prototype, "lead", void 0);
__decorate([
    property({ type: String })
], ErrorComponent.prototype, "iconName", void 0);
__decorate([
    property({ type: String })
], ErrorComponent.prototype, "buttonText", void 0);
ErrorComponent = __decorate([
    customElement('trust-error')
], ErrorComponent);
export { ErrorComponent };
//# sourceMappingURL=ErrorComponent.js.map